import { makeStyles } from '@material-ui/core';

export default makeStyles(() => ({
    root: {
        width: '100vw',
        backgroundColor: '#0d362f',
        color: '#fff',
    },
    divider: {
        backgroundColor: '#fff',
    },
    container: {
        marginTop: 60,
        marginBottom: 100,
    },
    media: {
        height: '12.5vw',
    },
    mobileMedia: {
        height: '28vw',
    },
    posts: {
        marginTop: 5,
    },
    link: {
        textDecoration: 'none',
        color: '#fff',
    },
    instagram: {
        // paddingBottom: 15,
    },
}));